export default __webpack_public_path__ + "static/media/steps13.bc19dbe2.png";